import React, { useState, useEffect } from "react";

export default function Home() {
  const images = [
    `${process.env.PUBLIC_URL}/images/home-banner.jpg`,
    `${process.env.PUBLIC_URL}/images/banner-4.jpg`,
    `${process.env.PUBLIC_URL}/images/It-support.jpg`,
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto change image every 5 sec
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);

    return () => clearInterval(interval);
  });

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <>
      {/* Banner Carousel */}
      <section className="banner">
        <img
          src={images[currentIndex]}
          alt="Carousel"
          className="banner-image"
        />

        {/* Prev Button */}
        <button onClick={handlePrev} className="carousel-btn prev-btn">
          ❮
        </button>

        {/* Next Button */}
        <button onClick={handleNext} className="carousel-btn next-btn">
          ❯
        </button>

        {/* Dots Indicator */}
        <div className="carousel-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <h2>Our Services</h2>
        <p className="service-paragraph">
          We provide end-to-end technology solutions designed to help businesses
          grow with confidence. From IT support to tailored training and
          enterprise software development, our services are built on innovation,
          reliability, and measurable impact. Whether you are a startup or an
          enterprise, we ensure your digital journey is seamless, secure, and
          future-ready.
        </p>
        <div className="highlights">
          <div className="highlight-item">✅ Scalable & Reliable Solutions</div>
          <div className="highlight-item">⚡ Industry-Specific Expertise</div>
          <div className="highlight-item">
            🤝 Long-Term Partnership Approach
          </div>
        </div>
        <div className="cards-container">
          <div className="card" data-aos="fade-up">
            <img
              src={`${process.env.PUBLIC_URL}/images/It-support.jpg`}
              alt="IT Support"
              className="service-img"
            />

            <h3>IT Support</h3>
            <p>We provide modern, reliable, and scalable IT solutions...</p>
          </div>
          <div className="card" data-aos="fade-up" data-aos-delay="100">
            <img
              src={`${process.env.PUBLIC_URL}/images/learning-development.jpg`}
              alt="Learning"
              className="service-img"
            />

            <h3>Learning & Development</h3>
            <p>
              Empowering individuals through customized training programs...
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
